// Click-to-load für eingebettete Player (Twitch/YouTube/TikTok):
// Externe Inhalte werden erst nach einem Klick geladen.
document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-mk-embed-load]') : null;
  if (!button) return;
  const embed = button.closest('[data-mk-embed]');
  const template = embed?.querySelector('template');
  if (!embed || !template) return;
  embed.replaceChildren(template.content.cloneNode(true));
  // Aus einem <template> geklonte Skripte laufen nicht von selbst – neu anlegen (z. B. TikTok embed.js)
  for (const old of embed.querySelectorAll('script')) {
    const script = document.createElement('script');
    for (const { name, value } of old.attributes) script.setAttribute(name, value);
    old.replaceWith(script);
  }
  embed.classList.add('is-loaded');
  embed.querySelector('iframe')?.focus();
});

// X-Post-iframe meldet seine Höhe per postMessage – iframe passend vergrößern
window.addEventListener('message', (event) => {
  if (event.origin !== 'https://platform.twitter.com') return;
  let data = event.data;
  if (typeof data === 'string') {
    try { data = JSON.parse(data); } catch { return; }
  }
  const call = data?.['twttr.embed'];
  const height = call?.method === 'twttr.private.resize' ? call.params?.[0]?.height : 0;
  if (!height) return;
  for (const frame of document.querySelectorAll('.mk-embed--x iframe')) {
    if (frame.contentWindow === event.source) frame.style.height = `${Math.ceil(height)}px`;
  }
});

// Schwebender Formful-Button „Verpasse keinen Spuk!“ (ohne verknüpftes Formular):
// springt zum Streamplan, auf Unterseiten zur Startseite mit Anker.
document.addEventListener(
  'click',
  (event) => {
    const button = event.target instanceof Element ? event.target.closest('.formful__dialog-button') : null;
    if (!button || button.getAttribute('data-dialog-id')) return;
    event.preventDefault();
    event.stopPropagation();
    const plan = document.getElementById('streamplan');
    if (plan) {
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      plan.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      // Falls sanftes Scrollen nicht ankommt (z. B. eingebettete Browser), direkt springen
      window.setTimeout(() => {
        if (Math.abs(plan.getBoundingClientRect().top) > 160) {
          const root = document.documentElement;
          const previous = root.style.scrollBehavior;
          root.style.scrollBehavior = 'auto';
          plan.scrollIntoView({ block: 'start' });
          root.style.scrollBehavior = previous;
        }
      }, 1200);
    } else {
      window.location.href = `${window.Shopify?.routes?.root ?? '/'}#streamplan`;
    }
  },
  true
);

// Süßigkeiten-Eimer: Beim Hoch- und Runterscrollen hüpfen Süßigkeiten heraus,
// solange der Eimer sichtbar ist.
(() => {
  const STEP = 70; // Pixel Scrollweg pro Süßigkeit
  const MAX_PIECES = 10;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  /** @type {HTMLElement[]} */
  let buckets = [];
  let lastY = window.scrollY;
  let travelled = 0;

  /** @param {HTMLElement} el */
  const inView = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  };

  const random = (min, max) => min + Math.random() * (max - min);

  /** @param {HTMLElement} bucket */
  function popCandy(bucket) {
    const pop = bucket.querySelector('[data-mk-candy-pop]');
    const template = bucket.querySelector('template[data-mk-candy-types]');
    if (!pop || !(template instanceof HTMLTemplateElement)) return;
    if (pop.childElementCount >= MAX_PIECES) return;

    const types = template.content.querySelectorAll('svg');
    if (!types.length) return;

    // Sprungweite und Größe wachsen mit dem Eimer mit
    const scale = Math.min(2.4, Math.max(1, bucket.offsetWidth / 150));
    const piece = document.createElement('span');
    piece.className = 'mk-candy__piece';
    piece.append(types[Math.floor(Math.random() * types.length)].cloneNode(true));
    piece.style.setProperty('--mk-dx', `${(random(-90, 130) * scale).toFixed(0)}px`);
    piece.style.setProperty('--mk-dy', `${(random(-170, -95) * scale).toFixed(0)}px`);
    piece.style.setProperty('--mk-rot', `${random(-260, 260).toFixed(0)}deg`);
    piece.style.setProperty('--mk-candy-size', `${(random(22, 36) * Math.sqrt(scale)).toFixed(0)}px`);
    piece.style.setProperty('--mk-candy-dur', `${random(0.9, 1.4).toFixed(2)}s`);
    piece.addEventListener('animationend', () => piece.remove(), { once: true });
    pop.append(piece);

    bucket.classList.remove('is-popping');
    void bucket.offsetWidth; // Wackel-Animation neu starten
    bucket.classList.add('is-popping');
  }

  function onScroll() {
    const y = window.scrollY;
    travelled += Math.abs(y - lastY);
    lastY = y;
    if (reduceMotion.matches || travelled < STEP) return;
    const count = Math.min(3, Math.floor(travelled / STEP));
    travelled = 0;
    for (const bucket of buckets) {
      if (!bucket.isConnected || !inView(bucket)) continue;
      for (let i = 0; i < count; i++) popCandy(bucket);
    }
  }

  function init() {
    buckets = Array.from(document.querySelectorAll('[data-mk-candy]'));
    if (!buckets.length) return;
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// Poltergeist: Alle 2 Minuten wackeln die Texte 5 Sekunden lang
// und die Reihenfolge der angezeigten Produkte wird durchgemischt.
(() => {
  const INTERVAL = 2 * 60 * 1000;
  const DURATION = 5000;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const LISTS = '.mk-rail__list, .product-grid';

  /** @param {Element} list */
  function shuffle(list) {
    const items = Array.from(list.children).filter((el) => el instanceof HTMLElement);
    if (items.length < 2) return;
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    for (const item of items) {
      list.append(item);
      item.classList.remove('mk-shuffle-fade');
      void item.offsetWidth;
      item.classList.add('mk-shuffle-fade');
      item.addEventListener('animationend', () => item.classList.remove('mk-shuffle-fade'), { once: true });
    }
  }

  function haunt() {
    if (reduceMotion.matches || document.hidden) return;
    const root = document.documentElement;
    root.classList.add('mk-poltergeist');
    window.setTimeout(() => {
      root.classList.remove('mk-poltergeist');
      for (const list of document.querySelectorAll(LISTS)) shuffle(list);
    }, DURATION);
  }

  window.setInterval(haunt, INTERVAL);
})();
